// Enum representing the various settlement statuses in the application

export enum SettlementStatusEnum {
    REGISTERED = 1,
    IN_PROGRESS = 2,
    FINISHED = 3,
    CANCELLED = 4,
    CONFIRMED = 5,
    REJECTED = 6,
    FAIL = 7,
    PAID = 8,
    DEBT_UNPAID = 9,
}